export default __webpack_public_path__ + "static/media/back_arrow.7569774c.svg";